module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-menu', {
    attrs: {
      "active-name": _vm.currentUrlAsMainMenuItemId,
      "open-names": [2],
      "theme": "dark",
      "width": "auto"
    },
    on: {
      "on-select": _vm.mainMenuItemSelect
    }
  }, [_c('MainMenuItems', {
    attrs: {
      "data": _vm.mainMenu,
      "lvl": 1,
      "deleteItemOnClick": _vm.mainMenuDeleteItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a24d068","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu/MainMenu.vue
// module id = 390
// module chunks = 0